import { FEATURED_FILTER, SEARCH } from "./actionTypes";

const initialState = {
  status: "All",
  search: "",
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURED_FILTER:
      return {
        ...state,
        status: action.payload,
      };

    case SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default filterReducer;
